import CampaignsService from 'services/campaignsService'
import { Contract } from 'types/campaigns'

const getContractsForCampaign = async (
  getAuthToken: () => Promise<string>,
  campaignId?: string
): Promise<Contract[] | undefined> => {
  if (!campaignId) return

  const token = await getAuthToken()
  const service = new CampaignsService(token)
  
  const result = await service.campaignsService.get(
    'StaffGetContractsForCampaign',
    {
      CampaignId: campaignId,
    }
  )

  return result.data
}

export default getContractsForCampaign
